import { FeatureMockFrame } from './FeatureMockFrame';
import type { FeatureMockSize } from './FeatureMockFrame';

export const PROGRAMS_PATHWAY_MOCK_ALT =
  'CourtSync development programs showing a player pathway from Red Ball through Orange, Green, and Yellow with skills and lesson prefill';

interface ProgramsPathwayMockProps {
  size?: FeatureMockSize;
  className?: string;
}

export function ProgramsPathwayMock({ size = 'compact', className }: ProgramsPathwayMockProps) {
  return (
    <FeatureMockFrame
      id="programs"
      alt={PROGRAMS_PATHWAY_MOCK_ALT}
      size={size}
      className={className}
    >
      <div className="csm-programs">
        <div className="csm-programs-header">Development pathway</div>
        <div className="csm-programs-ladder">
          <div className="csm-programs-stage csm-programs-stage--1">
            <div className="csm-programs-dot" />
            <div className="csm-programs-label">Red Ball</div>
            <div className="csm-programs-skills">
              <span className="csm-chip">Rally</span>
              <span className="csm-chip">Serve</span>
            </div>
          </div>
          <div className="csm-programs-connector csm-programs-connector--1" />
          <div className="csm-programs-stage csm-programs-stage--2">
            <div className="csm-programs-dot" />
            <div className="csm-programs-label">Orange Ball</div>
            <div className="csm-programs-skills">
              <span className="csm-chip">Consistency</span>
            </div>
          </div>
          <div className="csm-programs-connector csm-programs-connector--2" />
          <div className="csm-programs-stage csm-programs-stage--3">
            <div className="csm-programs-dot" />
            <div className="csm-programs-label">Green Ball</div>
            <div className="csm-programs-skills">
              <span className="csm-chip">Net play</span>
            </div>
          </div>
          <div className="csm-programs-connector csm-programs-connector--3" />
          <div className="csm-programs-stage csm-programs-stage--4">
            <div className="csm-programs-dot" />
            <div className="csm-programs-label">Yellow Ball</div>
            <div className="csm-programs-skills">
              <span className="csm-chip">Match play</span>
            </div>
          </div>
        </div>
        <div className="csm-programs-prefill">
          <div className="csm-prefill-title">Create lesson</div>
          <div className="csm-prefill-row">
            <span>Sport</span>
            <span className="csm-prefill-value">Tennis</span>
          </div>
          <div className="csm-prefill-row">
            <span>Age group</span>
            <span className="csm-prefill-value">Orange Ball</span>
          </div>
          <div className="csm-prefill-row">
            <span>Description</span>
            <span className="csm-prefill-value">Stage 2 pathway</span>
          </div>
        </div>
      </div>
    </FeatureMockFrame>
  );
}
